<template>
    <access-denied v-if="accessDenied" title="atendimentos" />
    <div class="page" v-else>
        <div class="vertical-flow">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">{{ $t('atendimentos') }}</h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs" v-if="cameFrom == 'route'">
                        <ul>
                            <li>
                                <a class="a-inativo">{{ $t('vendas') }}</a>
                            </li>
                            <li>
                                <a class="a-inativo">{{ $t('crm') }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{ $t('atendimentos') }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <template v-if="liberaExpostacao && permissao.export">
                        <div
                            v-if="exportacaoTipo != null && exportacaoTipo.exportaexcel == 1"
                            class="export-icon is-clickable"
                            @click="checkExport('excel')"
                        >
                            <b-icon 
                                icon="file-excel" 
                                size="is-medium" 
                                class="is-medium" 
                                v-tippy 
                                :title="$t('msg-tooltip-excel')"
                            />
                        </div>
                        <div
                            v-if="exportacaoTipo != null && exportacaoTipo.exportacsv == 1"
                            class="export-icon is-clickable"
                            @click="checkExport('csv')"
                        >
                            <b-icon 
                                icon="file" 
                                size="is-medium" 
                                class="is-medium" 
                                v-tippy 
                                :title="$t('msg-tooltip-csv')" 
                            />
                        </div>
                    </template>
                    <button
                        v-if="cameFrom != 'route'"
                        class="delete-btn"
                        type="button"
                        tag="button"
                        @click="$emit('voltar', true)"
                    >
                        {{ $t('voltar') }}
                    </button>
                    <button
                        v-if="!integracao && permissao.create && cameFrom == 'route'"
                        class="save-btn"
                        type="button"
                        tag="button"
                        @click="showModalAtendimentoManage = true"
                    >
                        {{ $t('adicionar') }}
                    </button>
                </div>
                <!-- Menu de Adição de atendimento -->
                <lateral-content v-model="showModalAtendimentoManage" confirmClose>
                    <AtendimentoManage
                        class="manage-content"
                        v-if="showModalAtendimentoManage"
                        cameFrom="AtendimentoList"
                        :uuidFrom="uuid"
                        @saved="
                            uuid = null;
                            reloadChild();
                        "
                        @redirectToEdit="
                            uuid = $event;
                            reloadChild();
                        "
                        @voltar="
                            uuid = null;
                            showModalAtendimentoManage = false;
                        "
                    />
                </lateral-content>
            </div>
            <!-- Tablela de Atendimentos -->
            <List
                ref="tabList"
                v-if="abasAbertas['list'] && permissao.read"
                v-show="abas[abaSelecionada] == 'list'"
                :reloadData="reloadChildData"
                @changeTab="changeTab"
                @filtros="filtros = $event"
                @changeLimit="limit = $event"
                @liberaExpostacao="liberaExpostacao = $event"
            />
            <Kanban
                ref="tabKanban"
                v-if="abasAbertas['kanban'] && permissao.read"
                v-show="abas[abaSelecionada] == 'kanban'"
                @changeTab="changeTab"
            />
        </div>
        <lateral-content
            v-model="isShowingTitle"
            compact
            footer
            header
            headerHideClose
            :title="$t('exportacao-dados')"
        >
            <div class="bg p-3">
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-12">
                            {{ $t('title-exp') }}
                        </div>
                        <div class="column is-12">
                            <v-input
                                ref="tituloExportacao"
                                v-model="tituloExportacao"
                                :maxlength="100"
                                title="titulo-exp"
                                required
                                :invalid="tituloExportacao == null"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template v-slot:footer-right="{ id }">
                <b-button type="is-primary" icon-right="filter" @click="saveExportacao()">
                    {{ $t('exportar-rel') }}
                </b-button>
            </template>
        </lateral-content>
    </div>
</template>

<script>
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';
import ExportacaoTipoService from '@/services/ExportacaoTipoService.js';
import ExportacaoService from '@/services/ExportacaoService.js';
import ExportacaoLogService from '@/services/ExportacaoLogService.js';
import ExportacaoDadosService from '@/services/ExportacaoDadosService.js';

// add rapido
const AtendimentoManage = () => import('@/components/vendas/atendimento/AtendimentoManage.vue');

// Abas
import List from '@/components/vendas/atendimento/abas-list/List.vue';
import Kanban from '@/components/vendas/atendimento/abas-list/Kanban.vue';

export default {
    name: 'AtendimentoList',

    components: {
        HideInfo,
        List,
        Kanban,
        AtendimentoManage,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('CRM_ATENDIMENTO'),
            exportacaoTipoService: new ExportacaoTipoService(this.$http, this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(this.$http, this.$router),
            exportacaoDadosService: new ExportacaoDadosService(this.$http, this.$router),
            abaSelecionada: 0,
            savedAbaSelecionada: 0,
            abas: ['list', 'kanban'],
            abasAbertas: {},
            permissao: false,
            accessDenied: false,
            showModalAtendimentoManage: false,
            reloadChildData: false,
            uuid: null,
            // Expostação
            exportacaoTipo: null,
            exportWithPhoto: false,
            isShowingTitle: false,
            tituloExportacao: null,
            filtros: null,
            liberaExpostacao: false,
            limit: null
        };
    },
    watch: {
        reloadData(val) {
            this.reloadChildData = val;
        },
    },
    created() {
        const cookie = this.$cookies.get('atendimento');
        if (cookie != undefined) {
            this.savedAbaSelecionada = cookie == 'true' ? 1 : 0;
        }

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-atendimento');
        if (!this.permissao.read) {
            this.accessDenied = true;
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos' },
            });
        } else {
            this.carregaExportacaoTipo();
            if (this.savedAbaSelecionada) {
                this.initTab(this.savedAbaSelecionada);
            } else {
                this.abasAbertas['list'] = true;
            }
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        initTab(i) {
            this.abaSelecionada = i;

            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        changeTab(i) {
            this.$emit('abaSelecionada', i);

            if (this.$cookies.get('atendimento') != undefined) {
                this.$cookies.remove('atendimento');
            }
            this.initTab(i);
        },
        reloadChild() {
            this.reloadChildData = true;
            setTimeout(() => (this.reloadChildData = false), 500);
        },
        // Carrega os tipos de exportações disponiveis para essa tela
        carregaExportacaoTipo() {
            // Inidica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela('CRM_ATENDIMENTO').then((body) => {
                if (body.content) {
                    this.exportacaoTipo = body.content;
                }
            });
        },
        checkExport(tipo) {
            this.exportWithPhoto = false;
            this.tipoExportacao = tipo;
            this.isShowingTitle = true;
        },
        // pedir se quer fotos se for pda
        promptExportPdf() {
            this.$root.confirm({
                message: this.$t('gerar-com-fotos'),
                onConfirm: () => {
                    this.exportWithPhoto = true;
                    this.isShowingTitle = true;
                },
                onCancel: () => {
                    this.exportWithPhoto = false;
                    this.isShowingTitle = true;
                },
            });
        },
        saveExportacao() {
            if (this.isNull(this.tituloExportacao)) {
                this.$refs.tituloExportacao.focusedOut = true;
                this.$root.showMessage('alert', 'msg-valida-titulo');
            } else {
                this.isSaving = true;
                this.isShowingTitle = false;

                let exportacao = {
                    idexportacao: null,
                    titulo: this.tituloExportacao,
                    processoexportado: this.tipoExportacao,
                    situacao: 'EXPORTANDO',
                    usuario: {
                        idusuarioerp: this.$store.state.user.idusuarioerp,
                    },
                    exportacaotipo: {
                        // //IDEXPORTACAOTIPO (REFERE-SE A QUAL TELA ESTA CHAMANDO A EXPORTACAO)
                        idexportacaotipo: this.exportacaoTipo.idexportacaotipo,
                    },
                };

                // salva o inicio da gração em fvw_exportacao
                this.exportacaoService
                    .save(exportacao)
                    .then((response) => {
                        this.$root.showMessage('success', 'msg-exp-solicitada');
                        this.saveLog(response.content, this.tipoExportacao);

                        this.gerarArquivoExportacao(response.content);
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar exportação.', e);
                        this.$root.showMessage('error', 'msg-erro-exp-gerar');
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            }
        },
        // Salva os dados na tabela fvw_exportacaolog
        saveLog(exportacao, tipo) {
            let exportacaoLog = {
                ///Objeto criado que será enviado ao banco
                destino: null,
                acao: 'Solicitação da exportação listagem ' + tipo,
                exportacao: exportacao,
                usuario: {
                    idusuarioerp: exportacao.usuario.idusuarioerp,
                },
            };
            this.exportacaoLogService
                .save(exportacaoLog)
                .then((r) => {})
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');
                });
        },
        gerarArquivoExportacao(exportacao) {
            this.filtros.datainicial = this.filtros.datainicial
                ? this.$moment(this.filtros.datainicial).format('YYYY-MM-DD')
                : null;

            this.filtros.datafinal = this.filtros.datafinal
                ? this.$moment(this.filtros.datafinal).format('YYYY-MM-DD')
                : null;

            let exportacaoAtendimento = {
                exportacao: exportacao,
                filtro: this.filtros,
                exportafoto: this.exportWithPhoto,
                usuario: this.$store.state.user,
            };
            this.exportacaoDadosService
                .saveAtendimentoList(
                    this.tipoExportacao,
                    exportacaoAtendimento,
                    this.column,
                    this.order,
                    this.limit
                )
                .then(() => {
                    this.tituloExportacao = '';
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    height: 100%;
    position: relative;
    padding-left: 0;
    .export-icon {
        color: var(--primary-color);
        padding-right: 5px;
    }
}
.filters-bar {
    display: flex;
    padding-top: 20px;
    .filters-bar-actions {
        display: flex;
        align-items: stretch;
    }
    .add {
        padding: 21px 18px;
    }
    @media screen and (max-width: 850px) {
        .filters-bar-actions {
            align-self: center;
        }
    }
}
.manage-content {
    padding: 20px;
}
</style>
